import { Typography } from "@mui/material";

const SaveReminder = ({ align = "right" }) => (
    <Typography
        variant="caption"
        sx={{
            display: "block",
            mt: 0.5,
            color: "text.secondary",
            fontStyle: "italic",
            textAlign: align,
        }}
    >
        Remember to save your answers before leaving this page or generating a report.
    </Typography>
);

export default SaveReminder;
